import { render, staticRenderFns } from "./BaseTextExpandable.vue?vue&type=template&id=76e9c1be&scoped=true&"
import script from "./BaseTextExpandable.vue?vue&type=script&lang=ts&"
export * from "./BaseTextExpandable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTextExpandable.vue?vue&type=style&index=0&id=76e9c1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9c1be",
  null
  
)

export default component.exports